import FetchImportedDocuments from '@Application/Beneficiaries/ImportedDocuments/Queries/FetchImportedDocuments';
import fetchImportedDocuments from '@Application/Beneficiaries/ImportedDocuments/fetchImportedDocuments';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import type ImportedDocumentsListView from '@UI/Store/ImportedDocuments/Views/ImportedDocumentsListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import type { UseStoreQueryResult } from '@verclam/synapse';

/**
 * The imported documents of one dossier. Every reader of this list declares it here, so they share one
 * cache entry and one request.
 */
const useSubjectImportedDocuments = (
	subject: SubjectAddress,
): UseStoreQueryResult<ImportedDocumentsListView | null> => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;

	return useStoreQuery({
		selector: (state) => state.importedDocumentsStore.importedDocuments,
		stopOn: (value) => value !== null && value.isFor(subject),
		query: () => dispatch(fetchImportedDocuments(new FetchImportedDocuments(facilityId, subject))),
		deps: [facilityId, subject],
	});
};

export default useSubjectImportedDocuments;
